export const MANUALAPI = 'https://manualapi.bosa.uat99.com/';
export const HUBHOME = 'https://hub.bosa.uat99.com/';
//export const MANUALAPI = 'https://145manualapi.msltest.com:5005/';
//export const HUBHOME = 'https://adminhub.msltest.com:5002';
//export const MANUALAPI = 'https://manualapi.uat.notreal.com/';
//export const HUBHOME = 'https://hub.uat.notreal.com/';

